"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var React = _interopRequireWildcard(require("react"));
var _reactIntl = require("react-intl");
var _styles = require("@material-ui/styles");
var _classnames = _interopRequireDefault(require("classnames"));
var _MultiSelectInput = _interopRequireDefault(require("../../Input/MultiSelectInput/MultiSelectInput"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/*:: import { type OptionsType, type ValueType } from '../../Input/MultiSelectInput/MultiSelectInput';*/
/*:: import { type ThemeType } from '../../style/ThemeTypes';*/
var useStyles = (0, _styles.makeStyles)(function (theme /*: ThemeType*/) {
  return {
    root: (0, _defineProperty2.default)({
      marginBottom: '.5rem'
    }, theme.breakpoints.gte.tablet.portrait, {
      display: 'inline-block',
      marginRight: '.75rem',
      marginBottom: 0
    }),
    label: _objectSpread(_objectSpread({}, theme.typography.smallText), {}, (0, _defineProperty2.default)({
      display: 'flex',
      alignItems: 'center',
      marginBottom: '.75rem',
      padding: '1rem .75rem .5rem',
      borderBottom: "1px solid ".concat(theme.colors.lightGrey)
    }, theme.breakpoints.gte.tablet.portrait, _objectSpread(_objectSpread({}, theme.mixins.infoBarLabel), {}, {
      borderBottom: 'none',
      padding: 0
    }))),
    input: _objectSpread({}, theme.mixins.inputResponsiveDropDown)
  };
});
/*:: type Props = {
  'data-testid'?: string,
  children?: React.Node,
  className?: string,
  disabled?: boolean,
  label?: string | React.Element<typeof FormattedMessage>,
  onChange?: (
    {
      currentTarget: {
        id?: string,
        label: React.Node,
        name?: string,
        value: ValueType
      }
    },
    ValueType,
    OptionsType
  ) => mixed,
  options?: OptionsType,
  placeholder?: string,
  value?: ValueType
};*/
var FilterSortItem = function FilterSortItem(_ref /*:: */) {
  var dataTestId = _ref /*:: */['data-testid'],
    children = _ref /*:: */.children,
    className = _ref /*:: */.className,
    disabled = _ref /*:: */.disabled,
    label = _ref /*:: */.label,
    onChange = _ref /*:: */.onChange,
    options = _ref /*:: */.options,
    placeholder = _ref /*:: */.placeholder,
    value = _ref /*:: */.value;
  var classes = useStyles();
  var id = label && typeof label === 'string' ? "filter-sort-item-".concat(label) : undefined;
  return /*#__PURE__*/React.createElement("div", {
    className: (0, _classnames.default)(classes.root, className)
  }, label && /*#__PURE__*/React.createElement("label", {
    className: classes.label,
    id: id
  }, label), children ? React.Children.map(children, function (child) {
    return React.isValidElement(child) ? React.cloneElement(child, {
      'aria-labelledby': id,
      className: (0, _classnames.default)(classes.input, child.props.className)
    }) : child;
  }) : /*#__PURE__*/React.createElement(_MultiSelectInput.default, {
    "aria-labelledby": id,
    className: classes.input,
    "data-testid": dataTestId,
    disabled: disabled,
    embedded: true,
    isClearable: false,
    isSearchable: false,
    onChange: onChange,
    options: options,
    placeholder: placeholder,
    value: value
  }));
};
FilterSortItem.displayName = 'FilterSortItem';
var _default = exports.default = FilterSortItem;
//# sourceMappingURL=FilterSortItem.js.map